import { Handle, HandleProps, Position } from "@xyflow/react"
import { cn } from "@/lib/utils"

interface CustomHandleProps extends Partial<HandleProps> {
  color: string
  isConnecting: boolean
  isConnected: boolean
  errorHandle?: boolean
}

function CustomHandle({ color, isConnecting, isConnected, errorHandle, ...props }: CustomHandleProps) {
  return (
    <Handle
      type="source"
      position={Position.Right}
      style={{
        backgroundColor: color,
      }}
      {...props}
      className={cn(
        "group !relative !top-0 !size-8 !rounded-none !border-none !bg-transparent fc z-10 !transform !translate-x-0 !translate-y-0",
        props.className,
        // isConnected ? "!-right-3.5" : "right-0",
        // errorHandle ? "!top-20" : "!top-11",
      )}
    >
      <div
        className={cn(
          `
            rounded-full g_handle_circle pointer-events-none shadow-node transition-[width,height,transform] duration-200

            group-hover:[background-color:var(--handle-hover-color)]
          `,
          isConnected
            ? "-ml-4 size-3"
            : `
              size-8 fc shadow

              group-hover:scale-110
            `,
        )}
        style={
          {
            "--xy-edge-stroke": errorHandle ? "var(--xy-edge-stroke-danger)" : "inherit",
            "--handle-hover-color": color,
            backgroundColor: isConnected ? "var(--xy-edge-stroke)" : "var(--background)",
          } as React.CSSProperties
        }
      >
        {!isConnected && (
          <IconIcRoundAddCircle
            className={`
              size-full

              [&_path]:stroke-[2.5px]
            `}
            style={{ color: errorHandle ? "var(--handle-unconnected-error)" : "var(--handle-unconnected)" }}
          />
        )}
      </div>
    </Handle>
  )
}

export default CustomHandle
